






import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { Contact } from '@/modules/Contact/interfaces/contact'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'

@Component({
  components: {
    AppSystemInfoCard
  }
})
export default class ContactDetailAdditional extends Vue {
  @Prop({ type: Object as () => Contact }) readonly contact!: Contact
}
